// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextAreaInline Component Styles
   Based on textArea.css — floating label removed, placeholder shown natively.
*/

:root {
  --scl--cms-components-textAreaInline-border-color:         var(--input-defualt);
  --scl--cms-components-textAreaInline-border-hover-color:   var(--input-hover);
  --scl--cms-components-textAreaInline-focus-color:          #2388FF;
  --scl--cms-components-textAreaInline-warning-color:        #FFC18E;
  --scl--cms-components-textAreaInline-error-color:          #F8868A;
  --scl--cms-components-textAreaInline-text-color:           var(--input-hover);
  --scl--cms-components-textAreaInline-placeholder-color:    var(--input-defualt);
  --scl--cms-components-textAreaInline-required-color:       #EB5252;
  --scl--cms-components-textAreaInline-assistive-text-color: rgba(255, 255, 255, 0.54);
  --scl--cms-components-textAreaInline-assistive-error:      #FF5252;
  --scl--cms-components-textAreaInline-assistive-warning:    #FFC18E;
  --scl--cms-components-textAreaInline-char-count-color:     var(--input-defualt);
}

/* ─── Container ──────────────────────────────────────────────────────────────── */

.scl--cms-components-textAreaInline-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

/* ─── Plate ──────────────────────────────────────────────────────────────────── */

.scl--cms-components-textAreaInline-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border: 1px solid var(--scl--cms-components-textAreaInline-border-color);
  border-radius: 3px;
  cursor: text;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  background: transparent;
}

/* Bottom focus accent bar */
.scl--cms-components-textAreaInline-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-textAreaInline-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--focused::after {
  opacity: 1;
}

.scl--cms-components-textAreaInline-plate:hover:not(.scl--cms-components-textAreaInline--focused) {
  border-color: var(--scl--cms-components-textAreaInline-border-hover-color);
}

.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--focused {
  border-color: var(--scl--cms-components-textAreaInline-border-hover-color);
}

.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--warning::after {
  background: var(--scl--cms-components-textAreaInline-warning-color);
  opacity: 1;
}

.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--error::after {
  background: var(--scl--cms-components-textAreaInline-error-color);
  opacity: 1;
}

.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── Inner wrapper ───────────────────────────────────────────────────────────── */

.scl--cms-components-textAreaInline-wrapper {
  display: flex;
  flex-direction: column;
  padding: 10px 12px 8px 12px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  flex-grow: 1;
}

/* ─── Textarea ───────────────────────────────────────────────────────────────── */

.scl--cms-components-textAreaInline-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  caret-color: var(--input-hover);
  color: var(--scl--cms-components-textAreaInline-text-color);
  padding: 0;
  box-sizing: border-box;
  resize: none;
  overflow: hidden;
}

/* Placeholder — visible by default, no label to animate from */
.scl--cms-components-textAreaInline-input::placeholder {
  color: var(--scl--cms-components-textAreaInline-placeholder-color);
  opacity: 1;
}

.scl--cms-components-textAreaInline-input:disabled {
  cursor: not-allowed;
}

/* ─── Character count footer ─────────────────────────────────────────────────── */

.scl--cms-components-textAreaInline-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 12px 6px 12px;
  width: 100%;
  box-sizing: border-box;
}

.scl--cms-components-textAreaInline-charCount {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.2px;
  color: var(--scl--cms-components-textAreaInline-char-count-color);
  transition: color 0.2s ease;
}

.scl--cms-components-textAreaInline-charCount.scl--cms-components-textAreaInline-charCount--limit {
  color: var(--scl--cms-components-textAreaInline-assistive-error);
}

/* ─── Assistive / Error / Warning text ───────────────────────────────────────── */

.scl--cms-components-textAreaInline-assistive {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 0px 14px;
  min-height: 16px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: var(--scl--cms-components-textAreaInline-assistive-text-color);
  width: 100%;
  box-sizing: border-box;
}

.scl--cms-components-textAreaInline-assistive.scl--cms-components-textAreaInline-assistive--error {
  color: var(--scl--cms-components-textAreaInline-assistive-error);
}

.scl--cms-components-textAreaInline-assistive.scl--cms-components-textAreaInline-assistive--warning {
  color: var(--scl--cms-components-textAreaInline-assistive-warning);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/textarea-field-op/css/textAreaInline.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,+EAA+E;EAC/E,6EAA6E;EAC7E,kEAAkE;EAClE,kEAAkE;EAClE,kEAAkE;EAClE,6EAA6E;EAC7E,+EAA+E;EAC/E,kEAAkE;EAClE,oFAAoF;EACpF,kEAAkE;EAClE,kEAAkE;EAClE,+EAA+E;AACjF;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mFAAmF;;AAEnF;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,wEAAwE;EACxE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,iEAAiE;EACjE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,mEAAmE;EACnE,UAAU;AACZ;;AAEA;EACE,iEAAiE;EACjE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oFAAoF;;AAEpF;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA,mFAAmF;;AAEnF;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,2DAA2D;EAC3D,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,kEAAkE;EAClE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;AAClE;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qEAAqE;EACrE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,kEAAkE;AACpE","sourcesContent":["/* TextAreaInline Component Styles\n   Based on textArea.css — floating label removed, placeholder shown natively.\n*/\n\n:root {\n  --scl--cms-components-textAreaInline-border-color:         var(--input-defualt);\n  --scl--cms-components-textAreaInline-border-hover-color:   var(--input-hover);\n  --scl--cms-components-textAreaInline-focus-color:          #2388FF;\n  --scl--cms-components-textAreaInline-warning-color:        #FFC18E;\n  --scl--cms-components-textAreaInline-error-color:          #F8868A;\n  --scl--cms-components-textAreaInline-text-color:           var(--input-hover);\n  --scl--cms-components-textAreaInline-placeholder-color:    var(--input-defualt);\n  --scl--cms-components-textAreaInline-required-color:       #EB5252;\n  --scl--cms-components-textAreaInline-assistive-text-color: rgba(255, 255, 255, 0.54);\n  --scl--cms-components-textAreaInline-assistive-error:      #FF5252;\n  --scl--cms-components-textAreaInline-assistive-warning:    #FFC18E;\n  --scl--cms-components-textAreaInline-char-count-color:     var(--input-defualt);\n}\n\n/* ─── Container ──────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textAreaInline-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n/* ─── Plate ──────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textAreaInline-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  border: 1px solid var(--scl--cms-components-textAreaInline-border-color);\n  border-radius: 3px;\n  cursor: text;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  background: transparent;\n}\n\n/* Bottom focus accent bar */\n.scl--cms-components-textAreaInline-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-textAreaInline-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--focused::after {\n  opacity: 1;\n}\n\n.scl--cms-components-textAreaInline-plate:hover:not(.scl--cms-components-textAreaInline--focused) {\n  border-color: var(--scl--cms-components-textAreaInline-border-hover-color);\n}\n\n.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--focused {\n  border-color: var(--scl--cms-components-textAreaInline-border-hover-color);\n}\n\n.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--warning::after {\n  background: var(--scl--cms-components-textAreaInline-warning-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--error::after {\n  background: var(--scl--cms-components-textAreaInline-error-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textAreaInline-plate.scl--cms-components-textAreaInline--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── Inner wrapper ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textAreaInline-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px 8px 12px;\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1;\n  flex-grow: 1;\n}\n\n/* ─── Textarea ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textAreaInline-input {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.25px;\n  caret-color: var(--input-hover);\n  color: var(--scl--cms-components-textAreaInline-text-color);\n  padding: 0;\n  box-sizing: border-box;\n  resize: none;\n  overflow: hidden;\n}\n\n/* Placeholder — visible by default, no label to animate from */\n.scl--cms-components-textAreaInline-input::placeholder {\n  color: var(--scl--cms-components-textAreaInline-placeholder-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textAreaInline-input:disabled {\n  cursor: not-allowed;\n}\n\n/* ─── Character count footer ─────────────────────────────────────────────────── */\n\n.scl--cms-components-textAreaInline-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 12px 6px 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-textAreaInline-charCount {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 14px;\n  letter-spacing: 0.2px;\n  color: var(--scl--cms-components-textAreaInline-char-count-color);\n  transition: color 0.2s ease;\n}\n\n.scl--cms-components-textAreaInline-charCount.scl--cms-components-textAreaInline-charCount--limit {\n  color: var(--scl--cms-components-textAreaInline-assistive-error);\n}\n\n/* ─── Assistive / Error / Warning text ───────────────────────────────────────── */\n\n.scl--cms-components-textAreaInline-assistive {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 4px 0px 14px;\n  min-height: 16px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: var(--scl--cms-components-textAreaInline-assistive-text-color);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-textAreaInline-assistive.scl--cms-components-textAreaInline-assistive--error {\n  color: var(--scl--cms-components-textAreaInline-assistive-error);\n}\n\n.scl--cms-components-textAreaInline-assistive.scl--cms-components-textAreaInline-assistive--warning {\n  color: var(--scl--cms-components-textAreaInline-assistive-warning);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
